
import { Vue, Options } from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import Avatar from "../atoms/Avatar.vue";
import { SelectableProfile } from "../../types";

@Options({
  components: { Avatar }
})
export default class UserSelector extends Vue {
  @Prop({ type: Array }) users: SelectableProfile[] = [];
  @Prop({ type: String }) userType: "employee" | "applicants" = "employee";
  @Prop({ type: String }) departmentId = "all";
  @Prop({ type: Boolean }) readOnly = true;
  @Prop({ type: Boolean }) selectable = true;
  @Prop({ type: Boolean }) isReading = false;
  currentUser: Partial<SelectableProfile> = {};
  onSelectionChange(event: Event, selectedUser: SelectableProfile) {
    const target = event.target as HTMLInputElement;
    this.$emit(
      "selection-change",
      Object.assign({}, selectedUser, {
        selected: target.checked
      })
    );
  }
  @Emit("user-click")
  onUserClick(selectedUser: SelectableProfile) {
    if (selectedUser !== this.currentUser) {
      this.currentUser = selectedUser;
    }
    return Object.assign({}, selectedUser, { selected: !!this.currentUser.id });
  }
}
